const transformFormValues = values =>
  Object.keys(values.translations || {}).map(locale => ({
    locale,
    ...values.translations[locale],
  }));

export default transformFormValues;
